import React, { useMemo, useState } from "react";
import { SectionHeader, SectionMoreLink } from "./SectionHeader";
import type { DisplayMenu } from "@/api/type";
import {
    DisplayMenuDetailModal,
    DisplayMenuHorizontalList,
    DisplayMenuHorizontalSkeleton,
    useDisplayMenus,
} from "./DisplayMenuShared";

interface DisplayMenuSectionProps {
    siteId: number;
    enabled: boolean;
    limit?: number;
}

export default function DisplayMenuSection({
    siteId,
    enabled,
    limit = 6,
}: DisplayMenuSectionProps) {
    const [selectedDisplayMenu, setSelectedDisplayMenu] = useState<DisplayMenu | null>(null);
    const { displayMenus, isLoading } = useDisplayMenus(siteId, enabled);

    const visibleDisplayMenus = useMemo(() => {
        return limit > 0 ? displayMenus.slice(0, limit) : displayMenus;
    }, [displayMenus, limit]);

    if (!enabled || (!isLoading && !displayMenus.length)) {
        return null;
    }

    return (
        <section className="p-6 pb-8">
            <SectionHeader title="메뉴 안내" action={<SectionMoreLink to="/display-menu" />} />

            {isLoading ? (
                <DisplayMenuHorizontalSkeleton />
            ) : (
                <DisplayMenuHorizontalList
                    displayMenus={visibleDisplayMenus}
                    onSelect={setSelectedDisplayMenu}
                />
            )}

            <DisplayMenuDetailModal
                displayMenu={selectedDisplayMenu}
                onClose={() => setSelectedDisplayMenu(null)}
            />
        </section>
    );
}
